import { eManulSortLayerDrawOrder, Game, rnd2 } from "../../Game";
import { eSprite, SPRITES } from "../../Sprites";
import { Node } from "../../Utils/Collections/Node";
import { NodeList } from "../../Utils/Collections/NodeList";
import { Pool } from "../../Utils/Collections/Pool";
import { TIMER } from "../Gameplay";
import { RoundManager } from "../Round/RoundManager";
import { TargetManager } from "../Targets/TargetManager";
import { Grandstand } from "./Grandstand";



class CameraFlashFx {
    private static readonly ANIM_FLASH = "flash";

    private _entity: pc.Entity;
    private _listNode: Node<CameraFlashFx>;
    private _onComplete: (node: Node<CameraFlashFx>) => void;
    private _onCompleteScope: any;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.sprite, {
            opacity: 0.9,
            layers: [Game.manualSortLayer.id],
            drawOrder: eManulSortLayerDrawOrder.flashFx
        });
        this._entity.enabled = false;
        Game.app.root.addChild(this._entity);

        // Animace
        let anim = this._entity.sprite.addClip({
            fps: 15,
            loop: false,
            name: CameraFlashFx.ANIM_FLASH,
            spriteAsset: SPRITES[eSprite.cameraFlash].getSpriteAssetId()
        });

        anim.on("end", this.handleAnimClipEnd, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._entity.enabled = false;
        this._listNode = null;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(pos: pc.Vec3, listNode: Node<CameraFlashFx>, onComplete: (node: Node<CameraFlashFx>) => void, onCompleteScope: any): void {
        this._listNode = listNode;
        this._onComplete = onComplete;
        this._onCompleteScope = onCompleteScope;

        // Zobrazit sprite
        let sprite = this._entity.sprite;

        sprite.stop();
        sprite.play(CameraFlashFx.ANIM_FLASH);

        this._entity.setLocalPosition(pos);
        this._entity.enabled = true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleAnimClipEnd(): void {
        this._onComplete.call(this._onCompleteScope, this._listNode);
        this.reset();
    }
}



export class CameraFlashFxManager {
    private static readonly INTERVAL = 150;

    /**
     * Tribuna
     */
    private _grandstand: Grandstand;
    /**
     * Cas, kdy ma dojit k zobrazeni dalsiho efektu
     */
    private _nextFxTime: number;
    /**
     * Pool s volnymi efekty
     */
    private _freeFxs: Pool<CameraFlashFx>;
    /**
     * Seznam aktivnich efektu
     */
    private _actFxs: NodeList<CameraFlashFx>;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(grandstand: Grandstand) {
        this._grandstand = grandstand;

        this._freeFxs = new Pool<CameraFlashFx>(undefined, 5, true, (): CameraFlashFx => { return new CameraFlashFx(); }, this);
        this._actFxs = new NodeList<CameraFlashFx>();

        this.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        // Uvolnit aktivni efekty
        this._actFxs.forEach((fx: CameraFlashFx): void => {
            fx.reset();
            this._freeFxs.returnItem(fx);
        });
        this._actFxs.clear();

        // Nastavit cas pro zobrazeni pristiho efektu
        this._nextFxTime = TIMER.time;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._nextFxTime <= TIMER.time) {
            // Nastavit cas zobrazeni dalsiho efektu
            this._nextFxTime += CameraFlashFxManager.INTERVAL;

            // Ziskat pozici pro efekt        
            let actZones = RoundManager.instance.roundSetup.actZones;
            let fx = this._freeFxs.getItem();
            let fxNode = this._actFxs.add(fx);
            let fxPos = this._grandstand.zones.getZoneRndPos(0.5, 0.5, actZones[rnd2.randomIntIn(0, actZones.length - 1)]);

            fx.show(fxPos, fxNode, this.handleFxComplete, this);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleFxComplete(node: Node<CameraFlashFx>): void {
        // Odstranit uzel ze seznamu aktivnich efektu
        this._freeFxs.returnItem(this._actFxs.removeByNode(node));
    }
}
